<template>
  <div ref="scroll">
    <slot></slot>
  </div>
</template>
<script>
import BScroll from '@better-scroll/core'
import ScrollBar from '@better-scroll/scroll-bar'
BScroll.use(ScrollBar)

export default {
  name: 'AppScroll',
  props: {
    /**
       * 点击列表是否派发click事件
       */
    click: {
      type: Boolean,
      default: true
    },
    /**
       * 列表的数据
       */
    data: {
      type: Array,
      default: null
    },
    /**
       * 当数据更新后，刷新scroll的延时。
       */
    refreshDelay: {
      type: Number,
      default: 20
    },
    /**
       * 滚动条
       */
    scrollbar: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    /**
       * 监听数据的变化，延时refreshDelay时间后调用refresh方法重新计算，保证滚动效果正常
       */
    data() {
      setTimeout(() => {
        this.refresh()
      }, this.refreshDelay)
    }
  },
  mounted() {
    /**
       * 保证在DOM渲染完毕后初始化better-scroll
       */
    setTimeout(() => {
      this._initScroll()
    }, 2000)
  },
  methods: {
    _initScroll() {
      if (!this.$refs.scroll) {
        return
      }
      // better-scroll的初始化
      this.scroll = new BScroll(this.$refs.scroll, {
        click: this.click,
        scrollbar: this.scrollbar
      })
    },
    disable() {
      // 代理better-scroll的disable方法
      this.scroll && this.scroll.disable()
    },
    enable() {
      // 代理better-scroll的enable方法
      this.scroll && this.scroll.enable()
    },
    refresh() {
      console.log('refresh')
      // 代理better-scroll的refresh方法

      this.$nextTick(() => {
        this.scroll && this.scroll.refresh()
      })
    },
    scrollTo() {
      // 代理better-scroll的scrollTo方法
      this.scroll && this.scroll.scrollTo.apply(this.scroll, arguments)
    },
    scrollToElement() {
      // 代理better-scroll的scrollToElement方法
      this.scroll && this.scroll.scrollToElement.apply(this.scroll, arguments)
    }
  }
}
</script>
<style type="text/css">
	.bscroll-vertical-scrollbar{
		background: #e0e0e0;
		width: 3px!important;
		opacity: 0.8!important;
		z-index: 9!important;  /*可调整*/
	}
	.bscroll-indicator{
			background: #b6b6b6!important;
			border:none!important;
		}
</style>
